<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="page-title">{{ $t('message.home.pointLottery') }}</div>

        <div class="lottery-wrap" v-if="lottery.id" v-loading="loading">
          <div class="lottery-info">
            <div class="lottery-name">{{ lottery.lotteryName }}</div>
            <div class="required-point">{{ $t('message.home.costPoints') }}: <strong>{{ lottery.requiredPoint }}</strong></div>
            <div class="my-point">{{ $t('message.home.myPoints') }}: <strong>{{ myPoint }}</strong></div>
          </div>

          <!-- Wheel visualization -->
          <div class="wheel-container">
            <div class="wheel" :style="{ transform: `rotate(${wheelDeg}deg)`, transition: spinning ? 'transform 4s cubic-bezier(0.17,0.67,0.12,0.99)' : 'none' }">
              <div class="prize-section" v-for="(prize, i) in prizes" :key="i"
                :style="{ transform: `rotate(${i * (360 / prizes.length)}deg)` }">
                <div class="prize-text">{{ prize.prizeName }}</div>
              </div>
            </div>
            <div class="wheel-pointer">▼</div>
          </div>

          <el-button type="primary" class="draw-btn" :loading="drawing" :disabled="spinning" @click="handleDraw">
            {{ $t('message.home.startLottery') }} ({{ lottery.requiredPoint }} {{ $t('message.home.points') }})
          </el-button>

          <div class="result-tip" v-if="result">
            <span v-if="result.isWinning">🎉 {{ $t('message.home.congratulations') }}: {{ result.prizeName }}</span>
            <span v-else>{{ $t('message.home.betterLuckNextTime') }}</span>
          </div>
        </div>

        <el-empty v-if="!lottery.id && !loading" :description="$t('message.home.noLottery')" />
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { getPointLottery, doPointLottery } from "@/api/marketing/point_mall";
import { load_member } from "@/api/upms/profile";
import { isShopLoggedIn } from "@/util/shopAuth";

export default {
  name: "PointLottery",
  data() {
    return { loading: false, drawing: false, lottery: {}, prizes: [], myPoint: 0,
      spinning: false, wheelDeg: 0, totalRotation: 0, result: null }
  },
  created() { this.loadLottery(); this.loadPoint() },
  methods: {
    loadLottery() {
      this.loading = true
      getPointLottery().then(r => {
        this.lottery = r.data?.data || {}
        this.prizes = this.lottery.prizes || []
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    loadPoint() {
      if (!isShopLoggedIn(this)) {
        this.myPoint = 0
        return
      }
      load_member().then(r => { this.myPoint = r.data?.data?.member?.point ?? 0 }).catch(() => {})
    },
    handleDraw() {
      if (!isShopLoggedIn(this)) {
        this.$router.push({ path: "/login", query: { redirect: this.$route.fullPath } })
        return
      }
      if (this.myPoint < this.lottery.requiredPoint) {
        this.$message.warning(this.$t('message.home.insufficientPoints'))
        return
      }
      this.drawing = true
      this.result = null
      doPointLottery(this.lottery.id).then(r => {
        const data = r.data?.data || {}
        const prizeIdx = data.wheelIndex || 0
        const segDeg = 360 / (this.prizes.length || 8)
        const stopDeg = prizeIdx * segDeg + segDeg / 2
        this.totalRotation += 1440 + (360 - (this.totalRotation % 360) - stopDeg + 360) % 360
        this.spinning = true
        this.wheelDeg = this.totalRotation
        setTimeout(() => {
          this.spinning = false
          this.drawing = false
          this.result = data
          this.myPoint = Math.max(0, this.myPoint - this.lottery.requiredPoint)
        }, 4200)
      }).catch(() => { this.drawing = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.page-title { font-size: 22px; font-weight: bold; margin-bottom: 24px; }
.lottery-wrap { background: #fff; border-radius: 8px; padding: 40px; text-align: center; max-width: 600px; margin: 0 auto; }
.lottery-name { font-size: 20px; font-weight: bold; margin-bottom: 12px; }
.required-point, .my-point { font-size: 15px; color: #606266; margin-bottom: 8px; }
.required-point strong, .my-point strong { color: #e6a23c; font-size: 18px; }
.wheel-container { position: relative; width: 300px; height: 300px; margin: 30px auto; }
.wheel { width: 100%; height: 100%; border-radius: 50%; background: conic-gradient(#ffd700 0deg 45deg, #ff6b6b 45deg 90deg, #4ecdc4 90deg 135deg, #45b7d1 135deg 180deg, #96ceb4 180deg 225deg, #ffeaa7 225deg 270deg, #dda0dd 270deg 315deg, #98fb98 315deg 360deg); position: relative; display: flex; align-items: center; justify-content: center; }
.prize-section { position: absolute; top: 10px; left: 50%; font-size: 11px; text-align: center; transform-origin: 0 140px; white-space: nowrap; font-weight: bold; color: #333; }
.prize-text { transform: rotate(22.5deg); }
.wheel-pointer { position: absolute; top: -20px; left: 50%; transform: translateX(-50%); font-size: 30px; color: #f56c6c; }
.draw-btn { width: 200px; height: 44px; font-size: 16px; margin-top: 20px; }
.result-tip { margin-top: 20px; font-size: 18px; font-weight: bold; color: #303133; }
</style>
